import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  PRODUCT_INFO_REQUEST,
  PRODUCT_INFO_SUCCESS,
  PRODUCT_INFO_FAILED,
  PRODUCT_INFO_CREATE,
  PRODUCT_INFO_CREATE_SUCCESS,
  PRODUCT_INFO_CREATE_FAILED,
  PRODUCT_INFO_DELETE,
  PRODUCT_INFO_DELETE_SUCCESS,
  PRODUCT_INFO_DELETE_FAILED,
  PRODUCT_INFO_EDIT,
  PRODUCT_INFO_EDIT_SUCCESS,
  PRODUCT_INFO_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * ProductInfo Actions
 */

function* fetchProductInfo({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Product/api/ProductInfo/GetProductInfo`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: PRODUCT_INFO_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: PRODUCT_INFO_FAILED, payload: error.response });
    }
  }
}

function* createProductInfo(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/ProductInfo/CreateProductInfo`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_INFO_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_INFO_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editProductInfo(action) {
  try {
    const response = yield call(
      axios.put,
      `${API_URL}/Product/api/ProductInfo/UpdateProductInfo`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_INFO_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_INFO_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteProductInfo(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/ProductInfo/RemoveProductInfo?ProductInfoId=${encodeURIComponent(action.payload.ProductInfoId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: PRODUCT_INFO_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_INFO_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootProductInfoList() {
  yield all([
    takeLatest(PRODUCT_INFO_REQUEST, fetchProductInfo),
    takeLatest(PRODUCT_INFO_CREATE, createProductInfo),
    takeLatest(PRODUCT_INFO_DELETE, deleteProductInfo),
    takeLatest(PRODUCT_INFO_EDIT, editProductInfo),
  ]);
}